import React, {
  ReactElement, ReactNode, useCallback, useMemo, useState,
} from 'react';
import { SprievodnyDokumentStatus } from 'evidencna-aplikacia-web-ts-axios';
import { useClient } from '../ClientStatusContext';
import {
  existsSprievodnyDokumentInAnyStadium,
} from '../../client/external/sprievodnyDokumentExistsClient';
import Context, { SprievodnyDokumentContextContent } from './SprievodnyDokumentContext';

interface Props {
  children: ReactNode;
}

const SprievodnyDokumentContextProvider = ({ children }: Props): ReactElement => {
  const [vznesenePripomienkyExistsStatus,
    setVznesenePripomienkyExistsStatus] = useState<SprievodnyDokumentStatus>(null);

  const { wrapClient } = useClient(existsSprievodnyDokumentInAnyStadium);
  const fetchVznesenePripomienkyExistsStatus = useCallback((
    legMaterialUuid: string,
    sprievodnyDokumentKod: string,
  ): void => {
    wrapClient(legMaterialUuid, sprievodnyDokumentKod)
      .then(({ data }) => setVznesenePripomienkyExistsStatus(data));
  }, [wrapClient]);

  const value: SprievodnyDokumentContextContent = useMemo(() => ({
    vznesenePripomienkyExistsStatus,
    fetchVznesenePripomienkyExistsStatus,
  }), [vznesenePripomienkyExistsStatus, fetchVznesenePripomienkyExistsStatus]);

  return (
    <Context.Provider value={value}>
      {children}
    </Context.Provider>
  );
};

export default SprievodnyDokumentContextProvider;
